import * as React from 'react';

import AddExternalServiceIntegration, {
	convertRequestToFrontendExternalRaterHeaders,
} from './modifiable/AddExternalServiceIntegration';

interface Props {
	externalServiceIntegrations: ExternalServiceIntegrationRequest[];
	onChange(externalServiceIntegrations: ExternalServiceIntegrationRequest[]): void;
}

interface State {
	externalServiceIntegrations: ExternalServiceIntegrationRequest[];
}

export const EMPTY_EXTERNAL_SERVICE_INTEGRATION_REQUEST: ExternalServiceIntegrationRequest = {
	name: '',
	url: '',
	headers: {},
};

function areExternalRaterHeadersValid(headers: FrontendExternalServiceIntegrationHeader[]) {
	return headers.every(({name, value}) => !!name && !!value);
}

function areExternalServiceIntegrationsValid(externalServiceIntegrations: ExternalServiceIntegrationRequest[]) {
	return externalServiceIntegrations.every(({name, url, headers}) => {
		return !!name && !!url
		&& areExternalRaterHeadersValid(convertRequestToFrontendExternalRaterHeaders(headers));
	});
}

export function isDeployEnabledPerRaterTypeNumberOfRaters(
	raterType: RaterType,
	externalServiceIntegrations: ExternalServiceIntegrationRequest[],
) {
	return raterType === 'EXTERNAL_RATER' ? externalServiceIntegrations.length > 0 : true;
}

export function isDeployEnabledPerRaterTypeValidFields(
	raterType: RaterType,
	externalServiceIntegrations: ExternalServiceIntegrationRequest[],
) {
	return raterType === 'EXTERNAL_RATER' ? areExternalServiceIntegrationsValid(externalServiceIntegrations) : true;
}

export default class ExternalServiceIntegrations extends React.Component<Props, State> {

	public state: State = {
		externalServiceIntegrations: this.props.externalServiceIntegrations,
	};

	constructor(props: Props, context: any) {
		super(props, context);
		this.handleAddExternalRater = this.handleAddExternalRater.bind(this);
		this.handleUpdateExternalRater = this.handleUpdateExternalRater.bind(this);
		this.handleDeleteExternalRater = this.handleDeleteExternalRater.bind(this);
		this.propagateChanges = this.propagateChanges.bind(this);
	}

	public render() {
		return <div className='external-service-integrations'>
			{this.renderAddExternalRaterButton()}
			{this.renderExternalServiceIntegrations()}
		</div>;
	}

	private renderAddExternalRaterButton() {
		return <button className='add-external-rater-button' onClick={this.handleAddExternalRater}>
			Add External Rater
		</button>;
	}

	private renderExternalServiceIntegrations() {
		return this.state.externalServiceIntegrations.map((e, i) => {
			return <AddExternalServiceIntegration
				key={i}
				requestIndex={i}
				externalServiceIntegrationRequest={e}
				onChange={this.handleUpdateExternalRater}
				onDelete={this.handleDeleteExternalRater}
			/>;
		});
	}

	private handleAddExternalRater() {
		this.setState({
			...this.state,
			externalServiceIntegrations: [
				...this.state.externalServiceIntegrations,
				EMPTY_EXTERNAL_SERVICE_INTEGRATION_REQUEST,
			],
		}, this.propagateChanges);
	}

	private handleUpdateExternalRater(requestIndex: number, request: ExternalServiceIntegrationRequest) {
		const externalServiceIntegrations = this.state.externalServiceIntegrations.map((e, i) => {
			return i === requestIndex ? request : e;
		});
		this.setState({
			...this.state,
			externalServiceIntegrations,
		}, this.propagateChanges);
	}

	private handleDeleteExternalRater(requestIndex: number) {
		const externalServiceIntegrations = this.state.externalServiceIntegrations.filter((e, i) => i !== requestIndex);
		this.setState({
			...this.state,
			externalServiceIntegrations,
		}, this.propagateChanges);
	}

	private propagateChanges() {
		this.props.onChange(this.state.externalServiceIntegrations);
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/external-service-integrations/ExternalServiceIntegrations.tsx